import { lazy } from 'solid-js';

const Offers = lazy(() => import('./Offers'));

export const CarrierMatchingRoute = {
  path: '/carrier/matching',
  load: () => import('./CarrierMatching'),
  protected: true,
};

export const CarrierMatchingOffersRoute = {
  pathRep: '/carrier/matching/offers',
  pathManager: '/carrier/matching/manager',
  load: () => import('./Offers'),
};

export const MyOffersRoute = {
  path: '/carrier/matching/offers',
  component: () => {
    return <Offers dataType="rep" />;
  },
  protected: true,
};

export const OffersManagerRoute = {
  path: '/carrier/matching/manager',
  component: () => {
    return <Offers dataType="manager" />;
  },
  protected: true,
};
